export default function setReactQueryDevToolsInitialized(value) {
  // eslint-disable-next-line no-underscore-dangle
  window.__LLY_REACT_QUERY_DEV_TOOLS_INITIALIZED__ = !!value;
}
